// LivestreamMiniModal.jsx
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ButtonId } from '../resource/mixpanel.js';

import media from '../style/media.js';
import SlideInFromBottom from '../style/SlideInFromBottom.js';
import SlideOutToBottom from '../style/SlideOutToBottom.js';

const defaultFunction = () => null;

export const LivestreamMiniModal = ({
  modalId = '',
  mixpanelModalId = '',
  status = 'hidden',
  toggleModal = defaultFunction,
  children = null,
}) => {
  const trackingPayload = useMemo(() => {
    return {
      modalId: mixpanelModalId,
    };
  }, [mixpanelModalId]);
  return (
    <Wrapper
      data-element_id={ButtonId.All.ButtonClose}
      data-tracking_payload={trackingPayload}
      onClick={() => {
        toggleModal({
          modalId,
          isOpen: false,
        });
      }}
    >
      <StyledMiniProfileModal $status={status}>
        {children}
      </StyledMiniProfileModal>
    </Wrapper>
  );
};

LivestreamMiniModal.propTypes = {
  status: PropTypes.string,
  modalId: PropTypes.string,
  mixpanelModalId: PropTypes.string,
  toggleModal: PropTypes.func,
  children: PropTypes.node,
};

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
`;

const StyledMiniProfileModal = styled.div`
  animation: 0.6s forwards
    ${({ $status }) => {
      switch ($status) {
        case 'opening':
          return SlideInFromBottom;
        case 'closing':
          return SlideOutToBottom;
        default:
          return '';
      }
    }};
  ${media.tablet`
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
  `};
`;

export default LivestreamMiniModal;
